<template lang='pug'>
div
    PQSensorsSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'en'")

        section.title-container
            h1.product-title KKE-24
            h2.product-subtitle Capacitive Medium Voltage Sensor

        section.margin-bottom
            .column-container
                .column.center-content
                    img( src='@/assets/photos/KKE-24.png', width="60%", alt='Power Quality MV Sensor KKE-24', title='Power Quality MV Sensor KKE-24')
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li Enables PQ measurement at MV installations
                            li Temperature-stable bandwidth up to 250 kHz
                    .bluebox
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet BSS KKE-24.pdf")
                        Maillink(to='support@bss-hs.de', sub='KKE-24', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(text="PQ Monitoring System PQM-800", to="/en/products/pqm-800")
        section.margin-bottom
            p The medium voltage sensor KKE-24 allows a direkt measurement of voltages up to 24 kV. It can be fitted with magnetic feet for installation into switching cabinets.

    div.fullwidth(v-if="$route.params.lang == 'de'")

        section.title-container
            h1.product-title KKE-24
            h2.product-subtitle Kapazitiver Mittelspannungssensor

        section.margin-bottom
            .column-container
                .column.center-content
                    source(type='image/webp', srcset='@/assets/photos/KKE-24.png')
                    img( src='@/assets/photos/KKE-24.png', width="60%", alt='Power Quality MV Sensor KKE-24', title='Power Quality MV Sensor KKE-24')
                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li Ermöglicht PQ-Messungen in MS-Anlagen
                            li Temperaturstabile Bandbreite bis zu 250 kHz
                    .bluebox
                        Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt BSS KKE-24.pdf")
                        Maillink(to='support@bss-hs.de', sub='KKE-24', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(text="PQ Monitoring System PQM-800", to="/en/products/pqm-800")
        section.margin-bottom
            p Mit dem Mittelspannungssensor KKE-24 kann die Spannung an Anlagen mit bis zu 24 kV direkt gemessen werden. Er kann mit Magnetfüßen für die Installation innerhalb von Schaltschränken ausgestattet werden.

</template>

<script>
import PQSensorsSelectorLinks from "./PQSensorsSelectorLinks.vue";
export default {
    components: {
        PQSensorsSelectorLinks,
    },
    meta: {
        de: {
            title: "BSS - PQ-Sensor - KKE-24",
            description:
                "Kapazitiver Power-Quality(PQ)-Sensor für Mittelspannungsanlagen",
        },
        en: {
            title: "BSS - PQ Sensor - KKE-24",
            description: "Capacitive Medium Voltage Power Quality (PQ) Sensor",
        },
    },
};
</script>

<style lang='sass' scoped>
@import '@/assets/sass/selector.sass'
</style>